import React, { useState, useEffect, useRef, useCallback, useContext } from 'react';
import { styled } from 'styled-components';
import { ReactComponent as arrowLeft } from "../assets/icons/icon-arrow-left.svg";
import { ReactComponent as arrowRight } from "../assets/icons/icon-arrow-right.svg";
import { 
  // Image, 
  // Box, 
  Text, 
  Heading, 
} from '@chakra-ui/react';
import { ScreenContext } from './ScreenProvider';
import { convertFontSize } from './Util';

export interface ISlider {
  images: any[];
};

const SlideContainer = styled.div`
  position: relative;
  background: #121212;
  color-scheme: light only;
  width: 100%;
  overflow-x: hidden;
`;

const SlideWrapper = styled.div<{ $index: number }>`
  display: flex;
  width: 100%;
  transform: translateX(-${(props)=>props.$index * 100}%);
  transition: transform 0.5s ease-in-out;
`;

/* const SlideImg = styled.img`
  width: 100%;
  object-fit: cover;
  flex-shrink: 0;
`;   */
//! object-fit: cover -> 이미지를 부모 요소에 맞춰 자동으로 크기 조정 (가로세로 비율 유지)
//! flex-shrink: 0 -> 다른 요소들이 공간을 차지할 때에도 해당 요소는 축소되지 않고 초기 크기를 유지
//   opacity: ${(props) => (props.isShow ? 1 : 0)};
// display: ${(props) => props.isShow ? "block" : "none"};

const SlideContent = styled.div`
  width: 100%;
  height: calc(100vh - 90px);
  display: flex;
  object-fit: cover;
  flex-shrink: 0;
  flex-direction: column;
  align-items: flex-end;

  @media (max-width: 768px) {
    height: calc(100vh - 50px);
  }
`; 
  // background: url(${(props) => props.back}) no-repeat center center;

const ContentSection = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  padding: 10%;
  flex: 1;

  @media (max-width: 1024px) {
    padding: 30% 10% 10% 10%;
    justify-content: start;
  }

  @media (max-width: 768px) {
    justify-content: start;
  }
`;

const SlideController = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  padding: 0 5%;
  position: absolute;
  left: 0;
  top: 0;
  justify-content: space-between;
  align-items: center;
`;

const SlideArrowLeft = styled(arrowLeft)`
  fill: #C8C8C8;
  cursor: pointer;
  &:hover {
  }
`;
const SlideArrowRight = styled(arrowRight)`
  fill: #C8C8C8;
  cursor: pointer;
  &:hover {
  }
`;

// const SlideCenterWrapper = styled.div`
//   width: 100%;
//   height: 100%;
//   display: flex;
//   flex-direction: column;
//   flex: 1;
// `;

// const SlideContentWrapper = styled.div`
//   width: 100%;
//   height: 50%;
//   color: white;
//   display: flex;
//   padding: 5%;
//   font-size: clamp(0.625rem, 0.4841rem + 0.6439vw, 1.875rem);
// `;

const SlideNavWrapper = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: flex-end;
`;

const SildeNavDot = styled.button<{ $isselected: string }>`
  width: ${(props) => props.$isselected === "true" ? "60px" : "20px"};
  height: 20px;
  margin: 30px 15px;
  border-radius: 10px;
  border: 1px solid #FDFDFD;
  background: ${(props) => props.$isselected === "true" ? "#FDFDFD" : "transparent"};
  cursor: ${(props) => props.$isselected === "true" ? "default" : "pointer"};
  &:hover {
    background: ${(props) => props.$isselected === "true" ? "#FDFDFD" : "#FDFDFD55"};
  }
`;

const SlideNavBanner: React.FC<ISlider> = ({ images }) => {
  const screen = useContext(ScreenContext).style;
  const sizes = {
    pc: "30px",
    tablet: "20px",
    mobile: "15px",
  };
  const [currentIndex, setCurrentIndex] = useState<number>(0);
  const [slideDir, setSlideDir] = useState<number>(1);  // 슬라이드 방향 -> 1: 정방향, -1: 역방향
  const maxNum = images.length;
  const timerRef = useRef<number | null>(null);
  const dirRef = useRef(slideDir);

  const startTimer = useCallback(() => {
    timerRef.current = window.setInterval(() => {
      setCurrentIndex(prevIndex =>
        (prevIndex + dirRef.current) % images.length
      );
    }, 3000);
  }, [images.length]);

  const resetTimer = useCallback(() => {
    if (timerRef.current) {
      clearInterval(timerRef.current);
      timerRef.current = null; // 타이머 참조 초기화
      startTimer();
    }
  }, [startTimer]);

  useEffect(() => {
    startTimer();

    return () => {
      if (timerRef.current) {
        clearInterval(timerRef.current);
      }
    };
  }, [images.length, startTimer]);

  useEffect(() => {
    if(currentIndex === 0) {
      setSlideDir(1);
    }
    if(currentIndex === maxNum - 1) {
      setSlideDir(-1);
    }
    resetTimer(); // currentIndex 변경 시에도 타이머를 초기화
  }, [currentIndex, maxNum, resetTimer]);

  useEffect(() => {
    dirRef.current = slideDir;
  }, [slideDir]);

  const prevSlide = () => {
    if(currentIndex === 0) {
      setCurrentIndex(
        (images.length - 1) % images.length
      );
    } else {
      setCurrentIndex(prevIndex =>
        (prevIndex - 1) % images.length
      );
    }
  };

  const nextSlide = () => {
    setCurrentIndex(prevIndex =>
      (prevIndex + 1) % images.length
    );
  };

  const _setCurrentIndex = (index: number) => {
    setCurrentIndex(index);
  };

  const setPager = () => {
    const arr = [];
    for(let i=0; i < images.length; i++) {
      arr.push(
        <SildeNavDot 
          key={i} 
          id={"slidenum"+i} 
          $isselected={(currentIndex === i).toString()} 
          onClick={() => _setCurrentIndex(i)} 
        />
      );
    }
    return arr;
  }

  return (
    <SlideContainer>
      <SlideWrapper $index={currentIndex}>
        {images.map((image, index) => (
          <SlideContent 
            key={index} 
            style={{ 
              backgroundColor: image.bgColor ?? "#121212",
              backgroundImage: `url('${image[screen]}')`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
            }}
          >
            <ContentSection>
              <Text 
                whiteSpace={"pre-wrap"} 
                lineHeight={"1.5"} 
                mb={"30px"} 
                fontSize={
                  screen === "pc" ? convertFontSize(22, 48)
                  : screen === "tablet" ? convertFontSize(22, 40, screen)
                  : convertFontSize(20, 20, screen)
                }
              >
                {image.title[screen]}
              </Text>
              <Text 
                color={"white"} 
                whiteSpace={"pre-wrap"} 
                lineHeight={"1.5"} 
                fontSize={
                  screen === "pc" ? convertFontSize(12, 24)
                  : screen === "tablet" ? convertFontSize(12, 18, screen)
                  : convertFontSize(10, 12, screen)
                }
              >
              {image.desc[screen]}
              </Text>
            </ContentSection>
          </SlideContent>
        ))}
        
      </SlideWrapper>
      {images.length > 1 &&
        <SlideController>
          <SlideArrowLeft width={sizes[screen]} onClick={prevSlide}/>
          <SlideNavWrapper>{setPager()}</SlideNavWrapper>
          <SlideArrowRight width={sizes[screen]} onClick={nextSlide}/>
        </SlideController>
      }
    </SlideContainer>
  );
};

export default SlideNavBanner;
